/**
 * Created by user on 2020/6/24.
 */
const _filters = {};

/**
 * 时间格式化
 */
_filters.fmtTimestamp = function(value, row, index) {
  if(!value) return '';
  var date = new Date(value);
  var yy = date.getFullYear();
  var MM = date.getMonth() + 1;
  var dd = date.getDate();
  var hh = date.getHours();
  var mm = date.getMinutes();
  var ss = date.getSeconds();
  if (MM < 10) MM = "0" + MM;
  if (dd < 10) dd = "0" + dd;
  if (hh < 10) hh = "0" + hh;
  if (mm < 10) mm = "0" + mm;
  if (ss < 10) ss = "0" + ss;

  // return "" + yy + "-" + MM + "-" + dd + " " + hh + ":" + mm + ":" + ss;
  return "" + yy + "-" + MM + "-" + dd;
};
_filters.fmtTimestamp3ny = function(value, row, index) {
  if(!value) return '';
  var date = new Date(value);
  var yy = date.getFullYear();
  var MM = date.getMonth() + 1;
  var dd = date.getDate();
  var hh = date.getHours();
  var mm = date.getMinutes();
  var ss = date.getSeconds();
  if (MM < 10) MM = "0" + MM;
  if (dd < 10) dd = "0" + dd;
  if (hh < 10) hh = "0" + hh;
  if (mm < 10) mm = "0" + mm;
  if (ss < 10) ss = "0" + ss;

  // return "" + yy + "-" + MM + "-" + dd + " " + hh + ":" + mm + ":" + ss;
  return MM + "/" + dd;
};
_filters.fmtTimestamp2Time = function(value, row, index) {
  if(!value) return '';
  var date = new Date(value);
  var yy = date.getFullYear();
  var MM = date.getMonth() + 1;
  var dd = date.getDate();
  var hh = date.getHours();
  var mm = date.getMinutes();
  var ss = date.getSeconds();
  if (MM < 10) MM = "0" + MM;
  if (dd < 10) dd = "0" + dd;
  if (hh < 10) hh = "0" + hh;
  if (mm < 10) mm = "0" + mm;
  if (ss < 10) ss = "0" + ss;

  return "" + yy + "-" + MM + "-" + dd + " " + hh + ":" + mm + ":" + ss;
};
_filters.fmtTimestamp2TimeHz = function(value, row, index) {
  if(!value) return '';
  var date = new Date(value);
  var yy = date.getFullYear();
  var MM = date.getMonth() + 1;
  var dd = date.getDate();
  var hh = date.getHours();
  var mm = date.getMinutes();
  var ss = date.getSeconds();
  if (MM < 10) MM = "0" + MM;
  if (dd < 10) dd = "0" + dd;
  if (hh < 10) hh = "0" + hh;
  if (mm < 10) mm = "0" + mm;
  if (ss < 10) ss = "0" + ss;

  return "" + yy + "年" + MM + "月" + dd +'日'+ " " + hh + ":" + mm ;
};

_filters.fmtTimestamp2Hour = function(value, row, index) {
  if(!value) return '';
  var date = new Date(value);
  var yy = date.getFullYear();
  var MM = date.getMonth() + 1;
  var dd = date.getDate();
  var hh = date.getHours();
  var mm = date.getMinutes();
  var ss = date.getSeconds();
  if (MM < 10) MM = "0" + MM;
  if (dd < 10) dd = "0" + dd;
  if (hh < 10) hh = "0" + hh;
  if (mm < 10) mm = "0" + mm;
  if (ss < 10) ss = "0" + ss;

  return "" + yy + "-" + MM + "-" + dd + " " + hh +'时';
};
_filters.fmtTimestampminute = function(value, row, index) {
  if(!value) return '';
  var date = new Date(value);
  var yy = date.getFullYear();
  var MM = date.getMonth() + 1;
  var dd = date.getDate();
  var hh = date.getHours();
  var mm = date.getMinutes();
  var ss = date.getSeconds();
  if (MM < 10) MM = "0" + MM;
  if (dd < 10) dd = "0" + dd;
  if (hh < 10) hh = "0" + hh;
  if (mm < 10) mm = "0" + mm;
  if (ss < 10) ss = "0" + ss;

  return "" + yy + "-" + MM + "-" + dd + " " + hh +':'+mm;
};
_filters.fmtTimestampMy = function(value, row, index) {
  if(!value) return '';
  var date = new Date(value);
  var yy = date.getFullYear();
  var MM = date.getMonth() + 1;
  var dd = date.getDate();
  var hh = date.getHours();
  var mm = date.getMinutes();
  var ss = date.getSeconds();
  if (MM < 10) MM = "0" + MM;
  if (dd < 10) dd = "0" + dd;
  if (hh < 10) hh = "0" + hh;
  if (mm < 10) mm = "0" + mm;
  if (ss < 10) ss = "0" + ss;

  return "" + yy + "-" + MM;
};
_filters.fmtTimestampHm = function(value, row, index) {
  if(!value) return '';
  var date = new Date(value);
  var yy = date.getFullYear();
  var MM = date.getMonth() + 1;
  var dd = date.getDate();
  var hh = date.getHours();
  var mm = date.getMinutes();
  var ss = date.getSeconds();
  if (MM < 10) MM = "0" + MM;
  if (dd < 10) dd = "0" + dd;
  if (hh < 10) hh = "0" + hh;
  if (mm < 10) mm = "0" + mm;
  if (ss < 10) ss = "0" + ss;

  return "" + hh + "时" + mm + "分";
};
export default Vue => {
  Object.keys(_filters).forEach(key => {
    Vue.filter(key, _filters[key]);
  });
};



// WEBPACK FOOTER //
// ./src/publicMethods/filters.js